import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ErrorComponent } from './shared/components/error/error.component';
import { NoRoleComponent } from './shared/components/no-role/no-role.component';

const child = [
  {
    path: '',
    loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule)
  }
];

const routes: Routes = [
  {
    path: 'location-picker',
    loadChildren: () => import('./location-picker/location-picker.module').then(m => m.LocationPickerModule)
  },
  {
    path: '',
    loadChildren: () => import('./location-picker/location-picker.module').then(m => m.LocationPickerModule)
  },
  {
    path: 'clusters/:cluster/factories/:factory',
    children: child
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'no-role',
    component: NoRoleComponent
  },
  {
    path: '**',
    redirectTo: 'location-picker',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
